<div class="d-flex flex-column" [style.gap.rem]="2">
  <app-primary-back-button label="Step 1" i18n-label (backClicked)="goBack()" />
  <section aria-labelledby="primary-contact-header" class="d-flex flex-column gap-4 pb-2">
    <div class="d-flex flex-column gap-3">
      <h3 i18n id="primary-contact-header" class="self-enrolment-header">Primary Contact</h3>
      <div class="paragraph-md" i18n>
        The primary contact will be responsible for the employer onboarding process, once the registration has been
        submitted.
      </div>
    </div>
    <app-employer-primary-contact-form-grid
      [form]="primaryContactForm"
      [formSubmitted]="formSubmitted"
      [countryCodeDropdowns]="countryCodeDropdowns$ | async" />
  </section>
  <ng-container *ngFor="let additionalContact of additonalContactForms.controls; let i = index">
    <hr class="m-0" />
    <section class="d-flex flex-column" [style.gap.rem]="2" [attr.aria-label]="'Additional Contact ' + (i + 1)">
      <app-employer-additional-contact-form-grid
        [form]="additionalContact"
        [index]="i"
        [formSubmitted]="formSubmitted"
        [countryCodeDropdowns]="countryCodeDropdowns$ | async" />
      <app-tertiary-button [size]="BaseButtonSizeEnum.md" (buttonClicked)="removeContact(i)" i18n
        >Remove</app-tertiary-button
      >
    </section>
  </ng-container>
  <hr class="m-0" />
  <app-tertiary-button
    [leftIconSrc]="'assets/icons/primary/Plus.svg'"
    [size]="BaseButtonSizeEnum.md"
    (buttonClicked)="addContact()"
    i18n
    >Add Another Contact</app-tertiary-button
  >
  <app-form-error
    *ngIf="formSubmitted && form.errors?.noSigningAuthority"
    [errors]="form.errors"
    [customErrorMessages]="formErrorMessages" />
  <div class="d-flex justify-content-end">
    <app-primary-button i18n [size]="BaseButtonSizeEnum.md" [isLoading]="isLoading$ | async" (buttonClicked)="submit()"
      >Submit Employer Registration</app-primary-button
    >
  </div>
</div>
